import React, { Component } from 'react'
import T from 'i18n-react'
import { Flex } from 'reflexbox'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

class SpecHeader extends Component {
  getModifiedRevisionHeader(){
    return this.props.modifiedRevisionLabel ? 
      this.props.modifiedRevisionLabel : 
      T.translate(`project.spec.header.modified.${this.props.tab}`)
  }

  getOriginalRevisionHeader(){
    return this.props.originalRevisionLabel ? 
      this.props.originalRevisionLabel : 
      T.translate(`project.spec.header.init.${this.props.tab}`)
  }

  render() {
    return (
      <div className={styles.specHeader}>
        <h2 className={styles.specTitle}>{ T.translate('project.spec.label') }</h2>
        <Flex className={styles.specItem}>
        <Flex className={styles.specLabel}>
            <span></span>
          </Flex>
          <Flex className={styles.specValue}>
            <span>{ this.getModifiedRevisionHeader() }</span>
          </Flex>
          { this.props.isModifiedPage &&
            <Flex className={styles.specValue}>
              <span>{ this.getOriginalRevisionHeader() }</span>
            </Flex>
          }
          { this.props.isModifiedPage &&
            <Flex className={styles.specValue}>
              <span>{ T.translate(`project.spec.header.risk.${this.props.tab}`) }</span>
            </Flex>
          }
        </Flex>
      </div>
    )
  }
}

export default CSSModules(SpecHeader, styles)
